import React, { useEffect, useState } from 'react';
import Nav from '../components/nav.tsx';
import Footer from '../components/footer.tsx';
import { contactImg } from '../configs/src_routes.ts';

const ContactPage = () => {

  const [imageLoaded, setImageLoaded] = useState<boolean>(false);

  useEffect(() => {
    const imageElement = document.getElementById('image') as HTMLImageElement | null;

    if (imageElement && imageElement.complete) {
      // 이미지가 이미 로드되어 있다면 이미지 로드 상태를 true로 설정
      setImageLoaded(true);
    } else if (imageElement) {
      // 이미지가 로드되지 않았다면 onLoad 이벤트를 추가하여 로드 완료 시 이미지 로드 상태를 true로 설정
      const handleImageLoad = () => {
        setImageLoaded(true);
      };
      imageElement.addEventListener('load', handleImageLoad);

      return () => {
        // 컴포넌트가 언마운트될 때 이벤트 리스너를 정리
        imageElement.removeEventListener('load', handleImageLoad);
      };
    }
  }, []);

  return (
    <div className='body-nav'>
      <div className={'loading-overlay'} style={{animationPlayState: (imageLoaded ? 'running' : 'paused')}}>
        <div className={'balls'}>
          <div />
          <div />
          <div />
        </div>     
      </div>
      <Nav />
      <div className='contact-container'>
        <div className='contact-body'>
          <h1>Contact Us<br/>for Further Information</h1>
          <div className='contact-cts'>
            <div className='contact-ct'>
              <div className='contact-label'>email</div>
              <span>contact@goldenwayve.com</span>
            </div>
            <div className='contact-ct'>
              <div className='contact-label'>address</div>
              <span>8 The Green, STE R, Dover, DE 19901, USA</span>
            </div>
          </div>
        </div>
        <img id='image' src={contactImg} alt='golden wave' />
      </div>
      <Footer />
    </div>
  );
};

export default ContactPage;